import { render, staticRenderFns } from "./_SingleSidebarItemOnboarding.vue?vue&type=template&id=69a95f9c&scoped=true"
import script from "./_SingleSidebarItemOnboarding.vue?vue&type=script&lang=js"
export * from "./_SingleSidebarItemOnboarding.vue?vue&type=script&lang=js"
import style0 from "./_SingleSidebarItemOnboarding.vue?vue&type=style&index=0&id=69a95f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a95f9c",
  null
  
)

export default component.exports